import { default as emotionStyled } from '@emotion/styled';

const styled = emotionStyled as StyledFixed;
const styledWithoutTheme = emotionStyled as StyledFixedWithoutTheme;
export { styled, styledWithoutTheme };
